module.exports = __webpack_public_path__ + "img/icon-book.2539cbf3.svg";